module.exports = {
  setCategory : function(mode){}
}



// WEBPACK FOOTER //
// ./src/wrappers/react-native-sound-wrapper.js